import styled from 'styled-components';

import { mediaMin } from '@spa/shared/theme';
import { StarContainer } from '@spa/shared/components/Reviews/StarRating/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${props => props.theme.space(5)} 0;
  border-top: 1px solid ${props => props.theme.borders.inputBorder};

  ${StarContainer} {
    width: 20px;

    span {
      width: 20px;
      height: 20px;
      font-size: ${props => props.theme.rem(20)};
      line-height: ${props => props.theme.rem(20)};

      @-moz-document url-prefix() {
        font-size: ${props => props.theme.rem(26)};
      }
    }
  }

  ${mediaMin.smallBreakpoint`
    flex-direction: column;
  `}
`;

export const ReviewerInfo = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.theme.gap(2)};

  ${mediaMin.smallBreakpoint`
    position: relative;
    margin-right: 0;

    svg {
      position: absolute;
      right: 0;
    }
  `}
`;

export const Name = styled.h3`
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(18)};
  font-weight: 600;
  line-height: ${props => props.theme.rem(20)};
  color: ${props => props.theme.reviews.text};

  span {
    padding-left: ${props => props.theme.space(2)};
  }
`;

export const Details = styled.span`
  width: 100%;
  color: ${props => props.theme.reviews.details};
  font-family: IntervalNextReg, sans-serif;
  font-size: ${props => props.theme.rem(16)};
  font-weight: 400;
  line-height: ${props => props.theme.rem(18)};
`;
